<template>
  <div id="mainLayout">
    <headNav v-if="!(isH5 || hideSideMenu)" />
    <router-view></router-view>
  </div>
</template>
<script>
import headNav from '@/components/headNav'

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      isH5: state => state.isH5,
      hideSideMenu: state => state.hideSideMenu,
    }),
  },
  components: {
    headNav,
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
<style scoped lang="less">
#mainLayout {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
